import { useCallback, useSyncExternalStore } from 'react';
import { LoadedDocumentHandle } from '../../services/ContentEditorService';
import { useContentEditorService } from '../../contexts/ContentEditorServiceContext';

/**
 * Subscribes to `service.changed` and returns the current
 * {@link LoadedDocumentHandle}, or undefined while no document is loaded.
 */
export function useLoadedDocumentHandle(): LoadedDocumentHandle | undefined {
  const service = useContentEditorService();

  // When the service emits 'changed', then re-read the handle. Emits after
  // unsubscribe (e.g. a sibling's `closeAndDiscard` cleanup) are simply ignored.
  const subscribe = useCallback(
    (onStoreChange: () => void) => service.on('changed', onStoreChange),
    [service],
  );
  return useSyncExternalStore(subscribe, () => service.loadedDocumentHandle);
}
